import { WebsitesStatus } from '@/models/websites.model';

export enum WebsiteFormType {
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum WebsiteFieldsNames {
  TITLE = 'title',
  DESCRIPTION = 'description',
  CHANNEL = 'channelId',
  IMAGE_TITLE = 'imageTitle',
  POSITION = 'position',
  STATUS = 'status',
  IMAGE = 'image',
}

export type TWebsiteFormValues = {
  [WebsiteFieldsNames.TITLE]: string;
  [WebsiteFieldsNames.DESCRIPTION]: string;
  [WebsiteFieldsNames.CHANNEL]: number;
  [WebsiteFieldsNames.IMAGE_TITLE]?: string;
  [WebsiteFieldsNames.POSITION]?: number;
  [WebsiteFieldsNames.STATUS]?: WebsitesStatus;
  [WebsiteFieldsNames.IMAGE]?: string;
};
